module.exports = __webpack_public_path__ + "img/btn-password.00295a01.png";